module.exports = __webpack_public_path__ + "img/logoLoading.7314d2ab.png";